export const FundingEnquiryStatus = Object.freeze({
  draft: 'DRAFT',
  sent: 'SENT',
  inProgress: 'IN_PROGRESS',
  cancelled: 'CANCELLED',
  completeClosed: 'COMPLETE_CLOSED',
  completeSearch: 'COMPLETE_SEARCH',
});

export const FundingEnquiryStatusLabel = Object.freeze({
  [FundingEnquiryStatus.draft]: 'Draft',
  [FundingEnquiryStatus.sent]: 'Sent',
  [FundingEnquiryStatus.inProgress]: 'In Progress',
  [FundingEnquiryStatus.completeClosed]: 'Complete',
  [FundingEnquiryStatus.completeSearch]: 'Complete',
  [FundingEnquiryStatus.cancelled]: 'Cancelled',
});

export const isEnquiryStatus = (status, type) => status === FundingEnquiryStatus[type];
